import { register } from "async-ops";
import { throwExceptionErrors } from "../../../utils/fetch";
import { callMdaePublicApi } from "../../../call-web-api";

export const GET_DOCUMENT_MANAGEMENT_CONFIG = "GET_DOCUMENT_MANAGEMENT_CONFIG";

export const service = async (attachedLevelName) => {
  const response: any = await callMdaePublicApi({
    type: "GET",
    contentType: "application/json",
    url: `/private/v1/documents/documentmanagementconfigurations?attachedLevelName=${attachedLevelName}`,
  });
  throwExceptionErrors(response);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => Promise.resolve(mockData());

register(GET_DOCUMENT_MANAGEMENT_CONFIG, service, mock);
